<template>
  <b-card no-body>

    <b-card-header>
      <div>
        <b-card-title class="mb-1">Paylaşım Günlük Analiz</b-card-title>
      </div>
      <div class="w-full dropdown-style d-flex">
        <div class="mt-1 mr-2">
          <b>
            {{ formatDate(rangeDate[0]) }} - {{ formatDate(rangeDate[1]) }}
          </b>
        </div>

        <div class="d-flex align-items-end">
          <v-select
            :options="rangeOptions"
            v-model="rangeSelect"
            :reduce="val => val.value"
            class="w-auto fixed-width btn text-primary p-0 dropdown-toggle btn-outline-primary"
            placeholder="Tarih Aralığı"
            :clearable="false"
            @input="updateRangeCustom"
          />

          <div v-if="rangeSelect === 'custom'" class="d-flex align-items-center ml-1">
            <feather-icon icon="CalendarIcon" size="20" @click="openDatePicker" class="cursor-pointer" />
            <flat-pickr
              ref="flatPickrRef"
              v-model="rangePicker"
              :config="{ mode: 'range', dateFormat: 'Y-m-d' }"
              class="form-control flat-picker bg-transparent border-0 shadow-none hide"
              @change="updateCustomRange"
            />
          </div>
        </div>
      </div>
    </b-card-header>
    <b-card-body>
      <vue-apex-charts v-if="loadCharts"
        type="area"
        height="400"
        :options="apexChatData.lineAreaChartSpline.chartOptions"
        :series="apexChatData.lineAreaChartSpline.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCardTitle } from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import flatPickr from 'vue-flatpickr-component';
import apexChatData from './apexChartData'
import vSelect from 'vue-select';
import axiosIns from '@/axios';

export default {
  components: {
    BCard,
    VueApexCharts,
    BCardHeader,
    BCardBody,
    BCardTitle,
    flatPickr,
    vSelect,
  },
  // apex-line-area-chart bileşeni içinde:
  props: {
    link_id: {
      type: [Number, String],
      default: null
    },
    inf_id: {
      type: [Number, String],
      default: null
    },
    link_type: {
      type: [Number, String],
      default: null
    },
    dateRangeCustom: {
      type: Object,
      default: () => ({
        start: null,
        end: null
      })
    }
  },
  data() {
    const today = new Date();
    const start = new Date(today);
    start.setDate(start.getDate() - 6); // Son 1 hafta (bugün dahil)

    return {
      apexChatData,
      rangeOptions: [
        { label: 'Son 1 Hafta', value: 'week' },
        { label: 'Son 2 Hafta', value: 'twoWeeks' },
        { label: 'Son 1 Ay', value: 'month' },
        { label: 'Özel Seçim', value: 'custom' },
      ],
      rangeSelect: 'week',
      rangeDate: [start, today],
      rangePicker: `${this.formatDate(start)} to ${this.formatDate(today)}`,
      loadCharts:false
    };
  },
  mounted() {
    if(this.dateRangeCustom['start']!=null && this.dateRangeCustom['end']!=null){
      this.updateDateRange();
    }else{
      this.fetchData();
    }
  },
  watch: {
    rangePicker(newValue) {
      if (this.rangeSelect === 'custom' && newValue.includes('to')) {
        const dates = newValue.split('to').map(date => date.trim()); // Tarihleri ayır ve gereksiz boşlukları kaldır
        if (dates.length === 2) { // Geçerli bir tarih aralığı olduğundan emin ol
          this.rangeDate = [dates[0], dates[1]];
          this.fetchData();
        }
      }
    },
    // start_date ve end_date prop'larını izle
    start_date(newVal) {
      if (newVal && this.end_date) {
        this.updateDateRange();
      }
    },
    end_date(newVal) {
      if (newVal && this.start_date) {
        this.updateDateRange();
      }
    }
  },
  methods: {
    updateDateRange() {
      const startDate = new Date(this.dateRangeCustom.start);
      const endDate = new Date(this.dateRangeCustom.end);
      this.rangeDate=[startDate,endDate]
      this.rangePicker = `${this.formatDate(startDate)} to ${this.formatDate(endDate)}`;
      this.rangeSelect = 'custom';
      this.fetchData();
    },
    async fetchData() {
      this.loadCharts = false;
      try {
        const [start, end] = this.rangeDate;
        // API parametrelerini hazırlama
        const params = {
          start_date: this.formatDate(start),
          end_date: this.formatDate(end),
        };
        
        // Props'lardan gelen değerleri ekle
        if (this.inf_id !== null) {
          params.inf_id = this.inf_id;
        }
        
        if (this.link_id !== null) {
          params.link_id = this.link_id;
        }
        
        if (this.link_type !== null) {
          params.link_type = this.link_type;
        }

        const response = await axiosIns.get('/analysis/dailySummary', { params });
        
        // API'den dönen verileri atama
        this.apexChatData.lineAreaChartSpline.series = response.data.series;
        this.apexChatData.lineAreaChartSpline.chartOptions.xaxis.categories = response.data.categories;
        this.loadCharts = true;
      } catch (error) {
        console.error('Veri çekme hatası:', error);
        this.loadCharts = true; // Hata durumunda da yükleme durumunu kaldır
      }
    },
    updateRangeCustom() {
      const today = new Date();
      let start = new Date(today); // Bugünün bir kopyasını oluştur

      if (this.rangeSelect === 'week') {
        start.setDate(today.getDate() - 6);
      } else if (this.rangeSelect === 'twoWeeks') {
        start.setDate(today.getDate() - 13);
      } else if (this.rangeSelect === 'month') {
        start = new Date(today.getFullYear(), today.getMonth(), 1);
      } else if (this.rangeSelect === 'custom') {
        setTimeout(() => {
          this.openDatePicker();
        }, 200);
      }
      if (this.rangeSelect !== 'custom') {
        this.rangeDate = [start, today];
        this.rangePicker = `${this.formatDate(start)} to ${this.formatDate(today)}`;
        this.fetchData();
      }

    },
    updateCustomRange(selectedDates) {
      if (selectedDates.length === 2) {
        const start = new Date(selectedDates[0]);
        const end = new Date(selectedDates[1]);
        this.rangeDate = [start, end];
        this.rangePicker = `${this.formatDate(start)} to ${this.formatDate(end)}`;
        this.fetchData();
      }
    },
    formatDate(date) {
      if (!(date instanceof Date)) date = new Date(date);
      
      const pad = (n) => n.toString().padStart(2, '0');

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());

      // this.rangePicker.end varsa saat bilgileri de dahil et
      if (this.dateRangeCustom?.end) {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } else {
        return `${year}-${month}-${day}`;
      }
    },
    
    openDatePicker() {
      const flatpickrInstance = this.$refs.flatPickrRef.fp;
      flatpickrInstance.open();
    },
  },
};
</script>


<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  .fixed-width {
    min-width: 230px; /* İhtiyaca göre genişliği ayarlayın */
    width: 100%;
  }
  .dropdown-style{
    .vs__dropdown-toggle{
      border:none; 
    }
    .vs__selected{
      color: var(--indigo) !important;
    }
    .dropdown-toggle::after{
      right: 10px;
      left: inherit;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .flat-picker.hide{
    width: 0;
    height: 0;
  }
</style>